<template>
	<div class="uupay-container">

    <blog-banner 
      :items="cardItems"
      link='/blogs/1'>
      <template v-slot:title>
        <div >高級餐廳閩粵軒如何利用微網紅行銷賺取達9.6倍回報？</div> 
      </template>
    </blog-banner>

    <section class="modules-section">
      <div class="container modules-section-container">
        <div class="content my-4">
          <div class="row">
            <div class="col-md-4">
              <div class="title">
                最新案例
              </div>
            </div>
            
          </div>
          <div class="row g-2 my-4">
            <div class="col-md-4" v-for="item in newBlogs">
              <div>
                <blog-card
                  :imageUrl="item.imageUrl"
                  :title="item.title"
                  :date="item.date"
                  :link="{ name: 'BlogDetail', params: { id: item.id } }"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="container modules-section-container">
        <div class="content my-4 pt-5">
          <div class="row">
            <div class="col-md-4">
              <div class="title">
                個例分析
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-8">
              <div class="business-content d-flex">
                <div class="d-flex">
                  <div class="mr-4" v-for="(item, index) in blogKinds">
                    <button class="business" :class="index == activeIndex ? 'business-selected': ''" @click="handleKind(index)">{{ item }}</button>
                  </div>
                </div>
                
              </div>
            </div>
            <div class="col-md-4">
              <div class="business-content business-more d-flex justify-content-end">
                <router-link to="/merchant/featured">
                  <div class="business d-flex justify-content-center align-items-center">
                    <div>更多</div>
                    <div><img src="@/assets/uupay/icon/svg/blog_arrow_right.svg" class="img-fluid"></div>
                  </div>
                </router-link>
              </div>
            </div>
          </div>

          <div class="row g-2 my-4">
            <div class="col-md-4" v-for="item in blogs">
              <div class="mb-5">
                <blog-card
                  :imageUrl="item.imageUrl"
                  :title="item.title"
                  :date="item.date"
                  :link="{ name: 'BlogDetail', params: { id: item.id } }"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

    </section>
  </div>
</template>
<script>
import BlogBanner from "@/components/BlogBanner";
import BlogCard from "@/components/BlogCard";

export default {
  name: 'UUPayMerchant',
  components: {
    BlogBanner,
    BlogCard
  },
  data() {
    return {
      cardItems: [
        {
          image: require('@/assets/uupay/images/merchant_banner.png'),
          title: '产品特色一',
          description: '详细介绍产品的主要特色和优势，吸引用户注意力',
          buttonText: '了解更多'
        },
        {
          image: require('@/assets/uupay/images/merchant_banner.png'),
          title: '产品特色二',
          description: '这是第二个产品的详细介绍内容，可以更长一些',
          buttonText: '立即购买'
        },
        {
          image: require('@/assets/uupay/images/merchant_banner.png'),
          title: '产品特色三',
          description: '第三个产品的说明文字，可以突出不同的卖点',
          buttonText: '查看详情'
        }
      ],
      newBlogs: [
        {id: 1, imageUrl: this.getImage('merchant_new_1'), date: '16/12/2025', title: '中小企必看｜Digital 2025香港報告出爐！超過8成港人活躍於社交平台 附實用營商建議', },
        {id: 2, imageUrl: this.getImage('merchant_new_2'), date: '16/12/2025', title: '中小企必看｜Digital 2025香港報告出爐！超過8成港人活躍於社交平台 附實用營商建議', },
        {id: 3, imageUrl: this.getImage('merchant_new_3'), date: '16/12/2025', title: '中小企必看｜Digital 2025香港報告出爐！超過8成港人活躍於社交平台 附實用營商建議', },
      ],
      activeIndex: 0,
      blogKinds: ['全部', '飲食', '服務'],
      blogs: [
        {id: 4, imageUrl: this.getImage('merchant_case_1'), date: '16/12/2025', title: '中小企必看｜Digital 2025香港報告出爐！超過8成港人活躍於社交平台 附實用營商建議', },
        {id: 5, imageUrl: this.getImage('merchant_case_2'), date: '16/12/2025', title: '中小企必看｜Digital 2025香港報告出爐！超過8成港人活躍於社交平台 附實用營商建議', },
        {id: 6, imageUrl: this.getImage('merchant_case_3'), date: '16/12/2025', title: '中小企必看｜Digital 2025香港報告出爐！超過8成港人活躍於社交平台 附實用營商建議', },
        {id: 7, imageUrl: this.getImage('merchant_case_4'), date: '16/12/2025', title: '中小企必看｜Digital 2025香港報告出爐！超過8成港人活躍於社交平台 附實用營商建議', },
        {id: 8, imageUrl: this.getImage('merchant_case_5'), date: '16/12/2025', title: '中小企必看｜Digital 2025香港報告出爐！超過8成港人活躍於社交平台 附實用營商建議', },
        {id: 9, imageUrl: this.getImage('merchant_case_6'), date: '16/12/2025', title: '中小企必看｜Digital 2025香港報告出爐！超過8成港人活躍於社交平台 附實用營商建議', },
      ]
    }
  },
  methods: {
    // 示例：跳转到指定幻灯片
    goToSlide(index) {
      this.$refs.banner.slideTo(index)
    },
    
    // 示例：暂停自动播放
    pauseBanner() {
      this.$refs.banner.stopAutoplay()
    },
    getImage(name) {
      return require(`@/assets/uupay/images/${name}.png`)
    },
    // 示例：恢复自动播放
    resumeBanner() {
      this.$refs.banner.startAutoplay()
    },
    handleKind(index) {
      this.activeIndex = index
    },

  },
  
}
</script>
<style scoped>


.modules-section {
  margin-top: 3rem;
  padding: 5rem 0;
  color: #21042e;
  background-color: #f8f8f8;
}

.modules-section .title {
  font-size: 42px;
  line-height: 60px;
  font-weight: 600;
  margin: 1.2rem 0;
}

@media (min-width: 1700px) {
  .modules-section-container {
    max-width: 1440px;
  }
}

@media (min-width: 1280px) {
  .modules-section .content {
    margin: 0 3rem;
  }
}

.modules-section .business-content {
  width: 100%;
  margin: 2rem 0;
}
.modules-section .business-more {
  width: 280px;
}
.modules-section .business {
  width: 120px;
  height: 50px;

  color: #21042e;
  background-color: #fff;
  border-radius: 50px;
  border: #f5f5f5 1px solid;

  font-size: 18px;
  line-height: 24px;
  font-weight: 400;
  cursor: pointer;
  transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;
}
.business:hover, .business:focus {
  text-decoration: none;
  outline: none;
  border: none;
}
.modules-section .business-selected {
  background: linear-gradient(to right, 
    #d054aa 0%, 
    #5a0a7e 100%);
  color: #fff;
  font-weight: 500;
  transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;
}

.business-body {
  font-size: 18px;
  line-height: 26px;
  font-weight: 400;
}
.business-body-title {
  width: 100%;
  height: 60px;
  color: #fff;
  background: linear-gradient(to right, 
    #d054aa 0%, 
    #5a0a7e 100%);
  font-size: 18px;
  line-height: 26px;
  font-weight: 500;
  border-radius: 10px;
  margin: 1.2rem 0;
}
.business-body-content {
  margin-bottom: 1.2rem;
}
.business-body-key {
  background-color: #f8f8f8;
  border-radius: 10px;
  border: #f5f5f5 1px solid;
  width: 100%;
  height: 100%;
}
.business-body-value {
  background-color: #f8f8f8;
  border-radius: 10px;
  border: #f5f5f5 1px solid;
  width: 100%;
  
}
.business-body-value-content {
  margin: 3rem;
}
.business-body-item-left {

}
.business-body-item-right {

}
.business-body-item {

}
.business-body-item-icon {
  margin-left: 0.4rem;
}

.modules-section .pos-content {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  padding: 4.5rem 0 2rem 0;
}

.modules-section .subtitle {
  font-size: 18px;
  line-height: 100%;
  color: #bc68a4;
}
.modules-section .pos-img {
  display: flex;
  justify-content: center;
  padding-top: 1.5rem;
}
.modules-section .pos-img-bg {
  background-image: url('/static/pos_bg.png');
  background-position: center;  
  background-size: cover;      
  background-repeat: no-repeat;
  width: 186px;
  height: 320px;
  display: flex;
  align-items: flex-end;
  justify-content: center;
}
.modules-section .content-row {
  margin: 40px 0;
}



</style>


// WEBPACK FOOTER //
// src/views/UUPayMerchant.vue